import { render, staticRenderFns } from "./NotificationCard.vue?vue&type=template&id=69429790&scoped=true&"
import script from "./NotificationCard.vue?vue&type=script&lang=js&"
export * from "./NotificationCard.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NotificationCard.vue?vue&type=style&index=1&id=69429790&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69429790",
  null
  
)

export default component.exports